import styled from 'styled-components'
import StyledIcon from '../styled-icon';
import { BodySmall } from '../typography/styled'
import SVG from "react-inlinesvg";
type ActiveProp = {
  active?:boolean,
  disable?:boolean,
  hover?:boolean,
  isOpen?:boolean,
}

export const Container = styled.div<ActiveProp>`
  display: flex;
  box-sizing: border-box;
  position: relative;
  flex-direction: column;
  width: ${({active}) => active ? '70px' : '280px'};
  transition: 0.2s width ease-in-out;
  /* position: absolute; */
  min-height: 100vh;
  padding: 30px 20px;
  z-index: 10;
  background-color: ${({theme}) => theme.palette[100]};
`
export const ArrowCloseImg = styled(SVG)<ActiveProp>`
  transform: ${({active}) => active ? 'scale(-1, 1)' : ''};
  transition: 0.2s transform ease-in-out;
  z-index: 9;
  opacity: ${({hover, disable}) => hover || disable ? '0.7' : ''};
  filter: ${({active, disable}) => active && !disable ? 'brightness(77%)' : ''};
  &:hover {
    cursor: pointer;
    opacity: ${({hover}) => hover ? '' : '0.7'};
  }
  &:active{
    filter: ${({disable}) => !disable ? 'brightness(77%)' : ''};
  }
  & path {
    stroke:${({theme}) => theme.palette[800]};
  }
  max-width:14px;
`
export const LogoImg = styled(SVG)<ActiveProp>`
  /* height: ${({active}) => active ? '26px' :'38px'};
  top: ${({active}) => active ? '27.5px' :'21px'}; */
  left:${({active}) => active ? '14.5px' :'15px'};
  top:26px;
  margin-bottom: 40px;
  margin-left: 8px;
  z-index: -1;
  position: absolute;
  &:hover{
    cursor:pointer;
    opacity: 0.7;
  }
  & path {
    /* fill:${({theme}) => theme.palette[800]}; */
  }
`
export const TitleDivider = styled.h2<ActiveProp>`
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 20px;
  padding: 8px 8px!important;
  margin-left: ${({active}) => active ? '14px' : ''};
  color: ${({theme, active}) => active ? theme.palette[700] : theme.palette[600]};
  text-transform: uppercase;
  white-space: nowrap;
`

export const CategoryHeader = styled.div<ActiveProp>`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 8px;
  margin-top: 8px;
  margin-bottom: 2px;
  margin-left: ${({active}) => active ? '8px' : '0'};
  cursor: pointer;
  border-radius: 0;
  transition: 0.15s all ease-in-out;
  border-left: ${({active}) => active ? 'none' : '3px solid'};
  border-left-color: ${({theme, isOpen}) => isOpen ? (theme.isDark ? '#7B9CFF' : '#4671F6') : (theme.isDark ? theme.palette[300] : '#E0E0E0')};
  position: relative;
  overflow: hidden;

  &:hover {
    background: ${({theme}) => theme.isDark ? theme.palette[200] : 'rgba(0, 0, 0, 0.04)'};
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: ${({theme, isOpen}) => {
      const color = isOpen
        ? (theme.isDark ? '#7B9CFF' : '#4671F6')
        : (theme.isDark ? theme.palette[600] : '#2D2D2D');
      return `linear-gradient(90deg, ${color}35, ${color}15 50%, transparent)`;
    }};
    transform: translateX(-100%);
    opacity: 0;
    pointer-events: none;
    transition: 2s;
  }

  &:active::after {
    animation: rippleSlide 2s cubic-bezier(0.08, 0.6, 0.3, 1) forwards;
  }

  @keyframes rippleSlide {
    0% {
      transform: translateX(-100%);
      opacity: 0.8;
    }
    100% {
      transform: translateX(100%);
      opacity: 0;
    }
  }

  .category-title {
    font-style: normal;
    font-weight: 700;
    font-size: 12px;
    line-height: 16px;
    letter-spacing: 0.8px;
    text-transform: uppercase;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    color: ${({theme, isOpen}) => isOpen
      ? (theme.isDark ? '#7B9CFF' : '#4671F6')
      : (theme.isDark ? theme.palette[800] : '#2D2D2D')
    };
  }

  color: ${({theme, isOpen}) => isOpen
    ? (theme.isDark ? '#7B9CFF' : '#4671F6')
    : (theme.isDark ? theme.palette[800] : '#2D2D2D')
  };
`

export const CategoryBadge = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  font-size: 10px;
  font-weight: 600;
  line-height: 1;
  background: ${({theme}) => theme.isDark ? theme.palette[300] : 'rgba(0, 0, 0, 0.08)'};
  color: ${({theme}) => theme.isDark ? theme.palette[700] : '#555'};
  flex-shrink: 0;
`

export const HideButton = styled.button`
  display: none;
  align-items: center;
  justify-content: center;
  width: 16px;
  height: 16px;
  border: none;
  border-radius: 3px;
  background: ${({theme}) => theme.isDark ? theme.palette[300] : 'rgba(0,0,0,0.1)'};
  color: ${({theme}) => theme.isDark ? theme.palette[700] : '#666'};
  cursor: pointer;
  font-size: 10px;
  padding: 0;
  flex-shrink: 0;
  &:hover {
    background: ${({theme}) => theme.isDark ? theme.palette[400] : 'rgba(0,0,0,0.2)'};
  }
`

export const ArrowCloseContainer = styled.div<ActiveProp>`
  display: flex;
  box-sizing: border-box;
  padding:7px;
  width:30px;
  top:25px;
  z-index: 9;
  height:30px;
  border-radius: 100%;
  background-color: ${({theme}) => theme.isDark ? theme.palette[600] : theme.base.white};
  border:${({theme}) => `1px solid ${theme.grey[300]}`};
  position:absolute;
  left:${({active}) => active ? '55px' : '265px'};
  transition: 0.2s left ease-in-out;
  filter: ${({theme}) => {
    return theme.isDark ? 'drop-shadow(0px 2px 2px rgba(0, 0, 0, 0.1))'
    : null}};
  &:hover{
    cursor:pointer;
    background-color:${({theme}) => theme.palette[100]}
  }
`
